"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiChip = void 0;
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
exports.MuiChip = {
    styleOverrides: {
        root: {
            fontWeight: global_1.fontWeight.bold,
            borderRadius: global_1.borderRadius.general,
        },
    },
    variants: [
        {
            props: {
                size: "small",
            },
            style: __assign(__assign({}, global_1.typography.regular12), { fontWeight: global_1.fontWeight.bold }),
        },
        {
            props: {
                variant: "filled",
                color: "warning",
            },
            style: {
                color: colors_1.colors.White,
            },
        },
    ],
};
//# sourceMappingURL=chip.js.map